



































































































































































































































import { defineComponent, reactive, toRefs, onMounted, computed, onBeforeUnmount, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
// @ts-ignore
import VueDragResize from "vue-drag-resize";
import { BModal } from 'bootstrap-vue';
import { WebupImage, ImageItem, Sheet, SearchCondition, Examinee, rotateHoseiPosition, DirectionEnum } from "../../modules/teacher/WebupDetail";
import { SplitterComponent, PanesDirective, PaneDirective } from "@syncfusion/ej2-vue-layouts"

export interface Data {
  webup_history_id: string | null
  filter: string | null
  sheet: Sheet
  webupImages: WebupImage[]
  imageItems: ImageItem[]
  selectedWebupImage: WebupImage | null
  selectedImageItem: ImageItem | null
  scale: number
  rotates: number[]
  currentPage: number
  perPage: number
  condition: SearchCondition
  examinees: Examinee[]
  totalCount: number
  fields: any[]
  errors: string[]
  circleSize: number,
  imagePadding: number
  DirectionEnum: Readonly<{Left: number; Right: number;}>
}

// @ts-ignore
export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "vue-drag-resize": VueDragResize,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/
    const modalSearchExaminee = ref<InstanceType<typeof BModal>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      webup_history_id: null,
      filter: "",
      sheet: null,
      webupImages: new Array<WebupImage>(),
      imageItems: new Array<ImageItem>(),
      selectedWebupImage: null,
      selectedImageItem: null,
      scale: 0.5,
      rotates: [0, 90, 180, 270],
      currentPage: 1,
      perPage: 10,
      condition: new SearchCondition(),
      examinees: new Array<Examinee>(),
      totalCount: 0,
      fields: [
        {key: "room_name", label: "教室", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_no_character", label: "受験番号", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
      ],
      errors: [],
      circleSize: 40,
      imagePadding: 30,
      DirectionEnum: DirectionEnum,
    });

    /************************************************************
     * 円形の補正マークの中心座標
     ************************************************************/

    const circleCenter = computed((): number => {
      return state.circleSize / 2;
    });

    /************************************************************
     * 補正マークのCSSスタイル
     ************************************************************/

    const tdStyle = computed((): {[key: string] : string} => {
      let style: any = {};
      style["width"] = `${circleCenter.value}px`;
      style["height"] = `${circleCenter.value}px`;
      return style;
    });

    /************************************************************
     * 補正マークのドラッグ終了イベント
     ************************************************************/

    const dragStop = (idx: number, rect: any) => {
      state.selectedWebupImage.hosei_positions[idx].rim[0] = Math.round(rect.left + circleCenter.value) / state.scale;
      state.selectedWebupImage.hosei_positions[idx].rim[1] = Math.round(rect.top + circleCenter.value) / state.scale;
    }

    /************************************************************
     * エラー有無を返却
     ************************************************************/

    const isExistsError = computed(() => {
      return state.webupImages.filter(x => x.errors.length > 0).length > 0;
    });

    /************************************************************
     * 絞り込み条件で絞った一覧
     ************************************************************/

    const filteredWebupImages = computed(() => {
      if(state.filter == "1"){
        return state.webupImages.filter(x => x.errors.length > 0);
      }else if(state.filter == "0"){
        return state.webupImages.filter(x => x.errors.length == 0);
      }else{
        return state.webupImages;
      }
    });

    /************************************************************
     * エラーレコードの件数
     ************************************************************/

    const errorCount = computed(() => {
      return state.webupImages.filter(x => x.errors.length > 0).length;
    });

    /************************************************************
     * 画面サイズに合わせてレイアウト整形
     ************************************************************/
    
    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      const imageArea = document.getElementById("image-area");
      const mainArea = document.getElementById("main-area");

      mainArea.style.height = (winH - mainArea.offsetTop) + "px";

      if(tableArea != null){
        tableArea.style.height = (winH - 230) + "px";
      }

      if(imageArea != null){
        imageArea.style.height = (winH - mainArea.offsetTop) + "px";
      }
    };

    /************************************************************
     * 画面表示エリアのCSSスタイル
     ************************************************************/

    const imageStyle = computed((): object => {
      let style: any = {};
      
      if(state.selectedWebupImage != null){
        style["width"] = `${state.selectedWebupImage.width * state.scale}px`;
        style["height"] = `${state.selectedWebupImage.height * state.scale}px`;
        style["transform"] = `rotate(${state.selectedWebupImage.angle}deg)`;
        
        // 回転の中心軸設定
        let translateX: string = "";
        let translateY: string = "";
        if(state.selectedWebupImage.angle == 90){
          translateX = `${state.selectedWebupImage.height * state.scale / 2}px`;
          translateY = `${state.selectedWebupImage.height * state.scale / 2}px`;
        }else if(state.selectedWebupImage.angle == 180){
          translateX = `${state.selectedWebupImage.width * state.scale / 2}px`;
          translateY = `${state.selectedWebupImage.height * state.scale / 2}px`;
        }else if(state.selectedWebupImage.angle == 270){
          translateX = `${state.selectedWebupImage.width * state.scale / 2}px`;
          translateY = `${state.selectedWebupImage.width * state.scale / 2}px`;
        }
        style["transform-origin"]  = `${translateX} ${translateY}`;
      }
      
      return style;
    });

    /************************************************************
     * imgの親divのCSSスタイル
     ************************************************************/
    
    const imageWrapStyle = computed((): object => {
      let style: any = {};
      if(state.selectedWebupImage != null){
        if(state.selectedWebupImage.angle == 0 || state.selectedWebupImage.angle == 180){
          style["height"] = `${(state.selectedWebupImage.height * state.scale) + 30}px`;
        }else{
          style["height"] = `${(state.selectedWebupImage.width * state.scale) + 30}px`;
        }
      }
      return style;
    });

    /************************************************************
     * 拡大ボタン押下
     ************************************************************/
    
    const scaleUp = () => {
      state.scale += 0.05;
    };

    /************************************************************
     * 縮小ボタン押下
     ************************************************************/
    
    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.05;
      }
    };

    /************************************************************
     * 画像を表示エリアの横幅に合わせる
     ************************************************************/
    
    const adjustWidth = () => {
      const elem = document.getElementById("image-area");
      if(elem != null){
        const imageAreaW = elem.clientWidth;
        const imageAreaH = elem.clientHeight;
        const imageW = state.selectedWebupImage.angle == 90 || state.selectedWebupImage.angle == 270 ? state.selectedWebupImage.height : state.selectedWebupImage.width;
        const imageH = state.selectedWebupImage.angle == 90 || state.selectedWebupImage.angle == 270 ? state.selectedWebupImage.width : state.selectedWebupImage.height;
        
        const scaleW = (imageAreaW - (state.imagePadding * 2))/ imageW;
        const scaleH = (imageAreaH - (state.imagePadding * 2))/ imageH;
        state.scale = scaleW > scaleH ? scaleH : scaleW;
      }
    };

    /************************************************************
     * 前へボタン押下
     ************************************************************/
    
    const prevCurrent = () => {
      const idx = state.webupImages.indexOf(state.selectedWebupImage);
      if(idx > 0){
        changeCurrent(state.webupImages[idx - 1]);
      }
    };

    /************************************************************
     * 次へボタン押下
     ************************************************************/
    
    const nextCurrent = () => {
      const idx = state.webupImages.indexOf(state.selectedWebupImage);
      if(state.webupImages.length > idx + 1){
        changeCurrent(state.webupImages[idx + 1]);
      }
    };

    /************************************************************
     * 左回転ボタン押下
     ************************************************************/
    
    const rotateLeft = () => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.selectedWebupImage.angle);
      if(rotateIdx == 0){
        angle = 270;
      }else{
        angle = state.selectedWebupImage.angle - 90;
      }
      state.selectedWebupImage.angle = angle;

      if(state.sheet.is_use_hosei){
        state.selectedWebupImage.hosei_positions = rotateHoseiPosition(state.selectedWebupImage.hosei_positions, DirectionEnum.Left, state.selectedWebupImage.angle, state.selectedWebupImage.width, state.selectedWebupImage.height);
      }
    };

    /************************************************************
     * 右回転ボタン押下
     ************************************************************/
    
    const rotateRight = () => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.selectedWebupImage.angle);
      if(rotateIdx == 3){
        angle = 0;
      }else{
        angle = state.selectedWebupImage.angle + 90;
      }
      state.selectedWebupImage.angle = angle;

      if(state.sheet.is_use_hosei){
        state.selectedWebupImage.hosei_positions = rotateHoseiPosition(state.selectedWebupImage.hosei_positions, DirectionEnum.Right, state.selectedWebupImage.angle, state.selectedWebupImage.width, state.selectedWebupImage.height);
      }
    };

    /************************************************************
     * 一括回転
     ************************************************************/
    
    const rotateAll = async (direction: number) => {

      if(!window.confirm(`一括回転を実行します。よろしいですか？`)){
        return;
      }

      state.webupImages.forEach(x => {
        let angle = 0;
        if(direction == DirectionEnum.Right){
          const rotateIdx = state.rotates.indexOf(x.angle);
          if(rotateIdx == 3){
            angle = 0;
          }else{
            angle = x.angle + 90;
          }
          x.angle = angle;

          if(state.sheet.is_use_hosei){
            x.hosei_positions = rotateHoseiPosition(x.hosei_positions, DirectionEnum.Right, x.angle, x.width, x.height);
          }
        }else{
          const rotateIdx = state.rotates.indexOf(x.angle);
          if(rotateIdx == 0){
            angle = 270;
          }else{
            angle = x.angle - 90;
          }
          x.angle = angle;

          if(state.sheet.is_use_hosei){
            x.hosei_positions = rotateHoseiPosition(x.hosei_positions, DirectionEnum.Left, x.angle, x.width, x.height);
          }
        }
      });
    };

    /************************************************************
     * 補正位置名取得
     ************************************************************/

    const getPosName = (idx: number) => {
      var posName = "";
      if(idx == 0){
        posName = "左上";
      }else if(idx == 1){
        posName = "左下";
      }else if (idx == 2){
        posName = "右下";
      }else{
        posName = "右上";
      }
      return posName;
    };

    /************************************************************
     * 補正処理
     ************************************************************/

    const perspectiveTransform = async () => {

      if(!window.confirm(`補正処理を実行します。よろしいですか？`)){
        return;
      }

      state.errors = []
      context.root.$store.dispatch("showOverlay");

      const param: any = {}
      param["result_hash"] = state.selectedWebupImage;

      await http.post(`/api/teacher/webup_detail/perspective_transform/${state.webup_history_id}/${state.selectedWebupImage.id}`, param).then(response => {
        state.selectedWebupImage.width = response.data.result_hash.width;
        state.selectedWebupImage.height = response.data.result_hash.height;
        let hosei_positions: number[][] = response.data.result_hash.hosei_positions;

        if(state.selectedWebupImage.angle == 90){
          [90].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedWebupImage.width, state.selectedWebupImage.height));
        }else if(state.selectedWebupImage.angle == 180){
          [90, 180].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedWebupImage.width, state.selectedWebupImage.height));
        }else if(state.selectedWebupImage.angle == 270){
          [90, 180, 270].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedWebupImage.width, state.selectedWebupImage.height));
        }

        state.selectedWebupImage.hosei_positions = hosei_positions;
        state.selectedImageItem.base64Image = response.data.base64_image;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 補正リセット
     ************************************************************/

    const resetTransform = async () => {
      if(!window.confirm(`補正をリセットします。よろしいですか？`)){
        return;
      }

      state.errors = []
      context.root.$store.dispatch("showOverlay");

      const param: any = {}
      param["result_hash"] = state.selectedWebupImage;

      await http.post(`/api/teacher/webup_detail/reset_transform/${state.webup_history_id}/${state.selectedWebupImage.id}`, param).then(response => {
        state.selectedWebupImage.width = response.data.result_hash.width;
        state.selectedWebupImage.height = response.data.result_hash.height;
        
        let hosei_positions: number[][] = response.data.result_hash.hosei_positions;
        if(state.selectedWebupImage.angle == 90){
          [90].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedWebupImage.width, state.selectedWebupImage.height));
        }else if(state.selectedWebupImage.angle == 180){
          [90, 180].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedWebupImage.width, state.selectedWebupImage.height));
        }else if(state.selectedWebupImage.angle == 270){
          [90, 180, 270].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedWebupImage.width, state.selectedWebupImage.height));
        }

        state.selectedWebupImage.hosei_positions = hosei_positions;
        state.selectedImageItem.base64Image = response.data.base64_image;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 選択中の画像情報変更
     ************************************************************/

    const changeCurrent = async (webupImage: WebupImage) => {
      
      state.selectedWebupImage = webupImage;
      const selectedImageItem = state.imageItems.filter(x => x.fileName == webupImage.file_name);

      // 画像キャッシュがない場合はロード
      if(selectedImageItem.length == 0){
        await http.get(`/api/teacher/webup_detail/download_image?webup_history_id=${state.webup_history_id}&file_name=${state.selectedWebupImage.file_name}`).then(response => {
          const imageItem = new ImageItem(state.selectedWebupImage.file_name, response.data.base64_image)
          state.imageItems.push(imageItem);
        });
      }

      state.selectedImageItem = state.imageItems.filter(x => x.fileName == webupImage.file_name)[0];
    };

    /******************************
     * 受験者検索API
     ******************************/

    const searchExaminee = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/webup_detail/search_examinee/${state.webup_history_id}?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.examinees = response.data.examinees.map((x: any) => new Examinee(x));
        state.totalCount = state.examinees.length == 0 ? 0 : state.examinees[0].full_count;
        state.currentPage = 1;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 受験者検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      searchExaminee();
    };

    /************************************************************
     * 再チェック
     ************************************************************/

    const reCheck = async () => {

      state.errors = []
      const idx = state.webupImages.indexOf(state.selectedWebupImage);
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/webup_detail/re_check/${state.webup_history_id}`, {webup_images: state.webupImages}).then(response => {
        state.webupImages = response.data.result_hashes.map((x: any) => new WebupImage(x));
        changeCurrent(state.webupImages[idx]);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 答案削除
     ************************************************************/

    const destroy = async (webupImage: WebupImage) => {

      if(!window.confirm("答案用紙を削除します。よろしいですか？")){
        return;
      }

      state.errors = []
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/webup_detail/destroy_webup_image/${state.webup_history_id}/${webupImage.id}`).then(async response => {

        if(response.data.webup_image_count > 1){
          const idx = state.webupImages.indexOf(webupImage);
          state.webupImages.splice(idx, 1);
          state.webupImages.forEach((x, i) => {
            x.sort_no = i + 1;
          });
          if(state.selectedWebupImage == webupImage){
            changeCurrent(state.webupImages[0]);
          }

          // 削除後に再チェック
          await reCheck();

          alert("処理が完了しました。");
        }else{
          alert("答案画像が0枚になりました。一覧画面に戻ります。");
          window.history.back();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 答案登録実行
     ************************************************************/

    const createJob = async () => {

      if(isExistsError.value){
        alert("エラーの答案が存在するため実行できません。エラーを解消してから実行してください。");
        return;
      }

      if(!window.confirm("答案用紙を登録します。よろしいですか？")){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/webup_detail`, {webup_history_id: state.webup_history_id, webup_images: state.webupImages}).then(response => {
        alert("登録処理を開始します。完了するまでしばらくお待ちください。登録が完了しましたら、各教室で切出しを実行してください。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      state.webup_history_id = context.root.$route.params.webup_history_id;
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中...しばらくお待ち下さい。");
      await http.get(`/api/teacher/webup_detail?webup_history_id=${state.webup_history_id}`).then(async response => {
        // QR読み込み結果を格納
        state.webupImages = response.data.result_hashes.map((x: any) => new WebupImage(x));

        state.sheet = response.data.sheet;
        
        // 選択画像を先頭行に設定
        changeCurrent(state.webupImages[0]);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      adjustHeight();
      adjustWidth();
      window.addEventListener("resize", adjustHeight);
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      modalSearchExaminee,
      filteredWebupImages,
      errorCount,
      changeCurrent,
      imageStyle,
      imageWrapStyle,
      scaleUp,
      scaleDown,
      adjustWidth,
      prevCurrent,
      nextCurrent,
      rotateLeft,
      rotateRight,
      rotateAll,
      reCheck,
      createJob,
      destroy,
      searchExaminee,
      clearCondition,
      changePage,
      getPosName,
      perspectiveTransform,
      resetTransform,
      circleCenter,
      tdStyle,
      dragStop,
    };
  }
});

